import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import fadeIn from '../fadeInAnim';


export const StyledContainer = styled.div`
  position: relative;
  top: -55px;
  display: ${props => (props.isVisible ? 'flex' : 'none')};
  background: #1e1e1e;
  min-height: 350px;
  width: 100%;

  @media ( max-width: 1200px) {
    flex-wrap: wrap;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex: 0 1 auto;
  padding: 30px 30px 100px;

  @media (min-width: 850px) {
    flex: 1 1 45%;
    padding: 40px 40px 100px;
  }
`;

export const EpisodesContainer = styled.div`
  display: flex;
  flex-direction: column;
  // align-items: center;
  box-sizing: border-box;
  // flex: 0 1 auto;
  width: 100%;
  padding: 30px 30px 100px;
`;

export const PlayerContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 0;
  justify-content: center;
  align-items: center;
  background: ${props => `url(${props.background})`};
  background-size: cover;
  padding: 100px 0;

  &:before {
    content: ' ';
    position: absolute;
    left: 0;
    width: 300px;
    height: 100%;
    background: linear-gradient(to right, rgba(30, 30, 30, 1) 5%, rgba(30, 30, 30, .3) 60%, rgba(30, 30, 30, 0) 100%);
  }

  @media (min-width: 850px) {
    flex: 1 1 55%;
  }
`;

export const StyledTitle = css`
  text-transform: uppercase;
  margin: 0;
  line-height: 1.2;
  animation: ${fadeIn};
`;

export const VideoTitle = styled.h2`
  ${StyledTitle}
  font-size: 2rem;
`;

export const StyledList = styled.ul`
  display: flex;
  list-style-type: none;
  font-size: 20px;
  margin: 10px 0;
  padding: 0;
  animation: ${fadeIn};

  li {
    margin-right: 15px;
  }
`;

export const VideoDescription = styled.div`
  font-size: 16px;
  line-height: 1.2;
  animation: ${fadeIn};
`;

export const VideoMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
`;

export const VideoNameTitle = styled.p`
  margin: 5px 0;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EpisodesHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const Form = styled.form`
  margin-left: 20px;

  select {
    background: #383B3B;
    border: 1px solid #272727;
    font-size: 16px;
    color: #fff;
    padding: 10px;
  }
`;

export const StyledPlayButton = styled(Link)`
  z-index: 5;
  border: 3px solid #0d63ff;
  border-radius: 50%;
  background: rgba(63, 81, 181, .4);
  padding: 20px;
  outline: 0;
  cursor: pointer;
  transition: all .4;

  &:hover {
    background: #0d63ff;
  }
`;

export const StyledCloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  border: 0;
  background: transparent;
  cursor: pointer;
`;
